import React, { PropTypes } from 'react';

const Welcome = (props) => {
    return (
        <div>
           <h1>Welcome soulmate javacript web framework</h1>
        </div>
    );
};


export default Welcome;



// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx